import React from 'react';
import { observer } from 'mobx-react-lite';
import { JobModel } from '../../entities'
import { useStore } from '../../store/storeHooks';
import { GenerativeAiProvider } from '@clipr/lib';
import classNames from 'classnames';
import { AiLogoSVGIcon } from '../svg';
import { DotSpinner } from '../loader';

type Props = {
  model: JobModel;
  teamId?: string | null;
  className?: string | null;
}

export const AiTag = observer(({
  model,
  teamId,
  className
}: Props) => {
  const store = useStore();
  const gptProvider: GenerativeAiProvider | null = store.aiService.getAiProvider(model, teamId);

  if (!gptProvider)
    return<></>;

  const isAiProcessing = model.isAiProcessing(gptProvider);
  const isAiDone = model.isAiDone(gptProvider);
  const aiProcessingTagClass = classNames(className, 
    'job-tag job-card-ai-tag', {
    'processing': isAiProcessing
  });

  const aiProcessingText = isAiProcessing ?
  <div className="spinner-container">
    Still processing 
    <DotSpinner 
    className="short-animation" 
    dots={3} />
  </div> : 'done';

  if (!isAiProcessing && !isAiDone)
    return <></>;

  return (
    <div className={aiProcessingTagClass}>
      <AiLogoSVGIcon /> {aiProcessingText}
    </div>
  )
  });